import script from "./SidebarFiltrosBI.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarFiltrosBI.vue?vue&type=script&setup=true&lang=js"

import "./SidebarFiltrosBI.vue?vue&type=style&index=0&id=2c4a352e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4a352e"]])

export default __exports__